import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth0 }                  from '@auth0/auth0-react';
import Avatar                        from './Avatar';

/*  ▸ Icons from react‑icons/FA  (Font Awesome subset)  */
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaChevronDown,
  FaSignOutAlt,
} from 'react-icons/fa';

export default function Navbar() {
  const {
    isAuthenticated,
    user: authUser,
    loginWithRedirect,
    logout,
    isLoading,
  } = useAuth0();

  const location = useLocation();
  const isGetStartedPage = location.pathname.startsWith('/getstarted');

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Debug: Log user data
  useEffect(() => {
    if (isAuthenticated && authUser) {
      console.log('Auth0 User Data:', authUser);
    }
  }, [isAuthenticated, authUser]);

  /* close dropdown on outside click */
  useEffect(() => {
    const handleClick = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogout = () => {
    logout({ 
      returnTo: window.location.origin,
      post_login_redirection_uri: window.location.origin 
    });
  };

  return (
    <header className="navbar">
      <div className="container navbar-content">
        {/* Brand */}
        <NavLink to="/" className="logo">
          <img src="/Musuko_Logo.png" alt="Musuko Logo" className="logo-img" />
          Musuko&nbsp;Media
        </NavLink>

        {/* Social icons */}
        <nav className={`contact-social ${isGetStartedPage ? 'getstarted-social' : ''}`}>
          <a
            href="https://www.facebook.com/profile.php?id=61563398802315"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/musukomedia"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/musukomedia"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </nav>

        {/* Auth area */}
        {!isGetStartedPage && (
          <div className="navbar-auth">
            {isLoading ? null : isAuthenticated ? (
              <>
                {/* User Profile Dropdown */}
                <div className="navbar__profile" ref={menuRef}>
                  <button
                    className="navbar__profile-btn"
                    onClick={() => setMenuOpen(o => !o)}
                    aria-label="User menu"
                  >
                    <Avatar
                      src={authUser?.picture}
                      name={authUser?.name || authUser?.email}
                      size={32}
                    />
                    <span className="navbar__username">
                      {authUser?.name || authUser?.email || 'User'}
                    </span>
                    <FaChevronDown
                      className={`navbar__chevron ${menuOpen ? 'open' : ''}`}
                    />
                  </button>

                  <div className={`profile-dropdown ${menuOpen ? 'active' : ''}`}>
                    <div className="dropdown__header">
                      <Avatar
                        src={authUser?.picture}
                        name={authUser?.name || authUser?.email}
                        size={40}
                      />
                      <div className="dropdown__user-info">
                        <div className="dropdown__name">
                          {authUser?.name || 'User'}
                        </div>
                        <div className="dropdown__email">
                          {authUser?.email}
                        </div>
                      </div>
                    </div>
                    <div className="dropdown__divider"></div>
                    <button
                      className="dropdown__item"
                      onClick={handleLogout}
                    >
                      <FaSignOutAlt /> Log&nbsp;out
                    </button>
                  </div>
                </div>
              </>
            ) : (
              /* Login Button - Only for non-authenticated users (landing page) */
              <button
                className="btn-login"
                onClick={() => loginWithRedirect()}
              >
                Login
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
